const COUNTRIES = Object.freeze({
  DZ: { name: 'Algeria', code: 'DZ' },
  EG: { name: 'Egypt', code: 'EG' },
  GH: { name: 'Ghana', code: 'GH' },
  CI: { name: 'Ivory Coast', code: 'CI' },
  KE: { name: 'Kenya', code: 'KE' },
  MA: { name: 'Morocco', code: 'MA' },
  NG: { name: 'Nigeria', code: 'NG' },
  SN: { name: 'Senegal', code: 'SN' },
  TN: { name: 'Tunisia', code: 'TN' },
  UG: { name: 'Uganda', code: 'UG' },
  ZA: { name: 'South Africa', code: 'ZA' }
})

const DEFAULT_COUNTRY = COUNTRIES.NG

const LANGUAGES = Object.freeze({
  EN: { code: 'en', name: 'English' },
  FR: { code: 'fr', name: 'Français' },
  AR: { code: 'ar', name: 'عربى' }
})

const ERROR_REASONS = Object.freeze({
  INVALID_COUNTRY: 'INVALID_COUNTRY'
})

const MAP_SETTINGS = Object.freeze({
  defaultZoom: 4,
  minZoom: 3,
  maxZoom: 16,
  defaultCenter: {
    longitude: 3.999311,
    latitude: 4.176547
  }
})

const PACKAGE_STATUS = Object.freeze({
  AT_SOURCE: 'AT_SOURCE',
  AT_THE_HUB: 'AT_THE_HUB',
  IN_TRANSIT: 'IN_TRANSIT',
  IN_PROGRESS: 'IN_PROGRESS',
  IN_PROGRESS_SUCCESS: 'IN_PROGRESS_SUCCESS',
  IN_PROGRESS_FAILURE: 'IN_PROGRESS_FAILURE',
  COMPLETED: 'COMPLETED',
  IN_EXCEPTION: 'IN_EXCEPTION',
  LOST: 'LOST',
  CANCELLED: 'CANCELLED',
  REVERSED: 'REVERSED'
})

export {
  COUNTRIES,
  DEFAULT_COUNTRY,
  LANGUAGES,
  ERROR_REASONS,
  MAP_SETTINGS,
  PACKAGE_STATUS
}
